import { getToken } from "services/auth/tokenAuth";
import doRequest from "services/helpers";
import { getUserId } from "services/storage/general";

export const requestGetCampusByResourceUser = async () => {
    const [result, err] = await doRequest(
        `/Usuario/ObtenerCampusPorUsuario/${getUserId()}`, "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.idCampus;
}
export const requestGetPenalties = async () => {
    const [result, err] = await doRequest(
        "/Recurso/ListarSanciones", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.sanciones.map(({
        idSancion, nombre, idMotivoSancion
    }) => ({
        id: idSancion,
        name: nombre,
        reasonForPenalizeId: idMotivoSancion
    }));
}
export const requestGetBlockList = async () => {
    const [result, err] = await doRequest(
        "/Recurso/ListarBloqueos", "GET", 
        null, getToken());
    if (err)
        return null;
    const { data } = result;
    if (data?.state !== 1)
        return null;
    return data.data?.bloqueos.map(({
        idBloqueo, nombre, idSancion
    }) => ({
        id: idBloqueo,
        name: nombre,
        penalizeId: idSancion
    }));
}